import React from "react";
import { useTranslation } from "react-i18next";
import { ErrorText } from "./ErrorText";
import parse from "html-react-parser";
export var Required = function (_a) {
    var label = _a.label, style = _a.style, _b = _a.className, className = _b === void 0 ? "" : _b;
    var t = useTranslation().t;
    return React.createElement(ErrorText, { style: style, className: className }, parse(t('errors.required_with_label', { label: label })));
};
